var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.972 5.303a4.179 4.179 0 1 1-8.358 0 4.179 4.179 0 0 1 8.358 0ZM3.151 10.41a1.857 1.857 0 0 0-1.857 1.857v8.357a6.5 6.5 0 0 0 12.999 0v-8.357a1.858 1.858 0 0 0-1.857-1.857H3.151Zm10.678-5.107a5.984 5.984 0 0 1-.966 3.274 3.693 3.693 0 0 1 2.013.892 4.183 4.183 0 0 0 3.563-1.5 4.165 4.165 0 0 0 .867-1.791 4.17 4.17 0 0 0-1.031-3.725 4.182 4.182 0 0 0-5.492-.542 5.992 5.992 0 0 1 1.046 3.392Zm-.464 21.551a8.337 8.337 0 0 0 2.785-6.23v-8.357a3.692 3.692 0 0 0-.498-1.857h4.212a1.857 1.857 0 0 1 1.857 1.857v8.357a6.504 6.504 0 0 1-2.614 5.212 6.508 6.508 0 0 1-5.742 1.018Zm7.892-21.551a5.984 5.984 0 0 1-.966 3.274 3.693 3.693 0 0 1 2.013.892 4.183 4.183 0 0 0 3.563-1.5 4.165 4.165 0 0 0 .867-1.791 4.17 4.17 0 0 0-1.031-3.725 4.182 4.182 0 0 0-5.492-.542 5.992 5.992 0 0 1 1.046 3.392Zm-.464 21.551a8.337 8.337 0 0 0 2.785-6.23v-8.357a3.701 3.701 0 0 0-.497-1.857h4.211a1.857 1.857 0 0 1 1.857 1.857v8.357a6.491 6.491 0 0 1-2.614 5.212 6.508 6.508 0 0 1-5.742 1.018Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/Inactive.94a44a0d.svg";
export { ForwardRef as ReactComponent };